import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

import { ReportParameterComponent } from '../report-parameter-list/report-parameter-component';
import { ReportParameterConfig } from '../report-parameter-list/report-parameter.config';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: BooleanReportParameterComponent }],
    selector: 'ndt-boolean-report-parameter',
    templateUrl: './boolean-report-parameter.component.html',
    standalone: false
})
export class BooleanReportParameterComponent implements OnDestroy, ReportParameterComponent {
   config: ReportParameterConfig;

   form: UntypedFormGroup;

   get label() {
      return this.config?.label;
   }

   destroyed$ = new Subject<void>();

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
